module.exports = __webpack_public_path__ + "static/media/Dinerkaart.70404871.pdf";